module.exports = __webpack_public_path__ + "img/hero.9323f4a5.png";